import { Component, Fragment } from "react";
import { autorun } from "mobx";
import { inject, observer } from "mobx-react";
import PageHeaderLayout from "layouts/PageHeaderLayout";

import { AgGridReact } from "ag-grid-react";
import "ag-grid/dist/styles/ag-grid.css";
import "ag-grid/dist/styles/ag-theme-balham.css";
import { Card, Row, Button, Form, Input, Tooltip, Icon, Col, Modal } from 'antd';
import AddCloudAccountDrawer from "./components/AddCloudAccountDrawer";
import EditCloudAccountDrawer from "./components/EditCloudAccountDrawer";
import { CloudServicesEnum } from "common/cloudServices";

function getTextFilter(type) {
    function TextFilter() { }

    TextFilter.prototype.init = function (params) {
        this.valueGetter = params.valueGetter;
        this.filterText = null;
        this.setupGui(params);
    };

    // not called by ag-Grid, just for us to help setup
    TextFilter.prototype.setupGui = function (params) {
        this.gui = document.createElement("div");
        this.gui.innerHTML =
            '<div style="padding: 4px;">' +
            '<div style="font-weight: bold;">Search for ' +
            type +
            "</div>" +
            '<div><input style="margin: 4px 0px 4px 0px;" type="text" id="filterText" placeholder="' +
            type +
            '..."/></div>' +
            '<div style="margin-top: 5px; width: 200px;">Enter ' +
            type +
            " that you want to search for</div>" +
            "</div>";

        this.eFilterText = this.gui.querySelector("#filterText");
        this.eFilterText.addEventListener("changed", listener);
        this.eFilterText.addEventListener("paste", listener);
        this.eFilterText.addEventListener("input", listener);
        // IE doesn't fire changed for special keys (eg delete, backspace), so need to
        // listen for this further ones
        this.eFilterText.addEventListener("keydown", listener);
        this.eFilterText.addEventListener("keyup", listener);
        this.filterChangedCallback = params.filterChangedCallback;

        var that = this;

        function listener(event) {
            that.filterText = event.target.value;
            params.filterChangedCallback();
        }
    };

    TextFilter.prototype.getGui = function () {
        return this.gui;
    };

    TextFilter.prototype.doesFilterPass = function (params) {
        // make sure each word passes separately, ie search for firstname, lastname
        var passed = true;
        var valueGetter = this.valueGetter;
        var value = valueGetter(params);
        if (
            value
                .toString()
                .toLowerCase()
                .indexOf(this.filterText.toLowerCase()) < 0
        ) {
            passed = false;
        }
        if (passed && this.filterText.toLowerCase() == "wordpress.com") {
            console.log(params);
        }
        return passed;
    };

    TextFilter.prototype.isFilterActive = function () {
        var isActive =
            this.filterText !== null &&
            this.filterText !== undefined &&
            this.filterText !== "";
        return isActive;
    };

    TextFilter.prototype.getApi = function () {
        var that = this;
        return {
            getModel: function () {
                var model = { value: that.filterText.value };
                return model;
            },
            setModel: function (model) {
                that.eFilterText.value = model.value;
            }
        };
    };

    TextFilter.prototype.getModelAsString = function (model) {
        return model ? model : "";
    };

    TextFilter.prototype.getModel = function () {
        return this.filterText;
    };
    // lazy, the example doesn't use setModel()
    TextFilter.prototype.setModel = function (params) {
        if (!params) {
            this.filterText = "";
            this.eFilterText.value = "";
            this.filterChangedCallback();
        }
    };

    return TextFilter;
}

@inject("rootStore")
@observer
class CloudAccountsPage extends Component {
    onGridReady = params => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;

        const {
            rootStore: { cloudAccountsStore }
        } = this.props;

        const ui = cloudAccountsStore.ui;

        this.deleteAccountDisposer = autorun(() => {
			if (ui.deletedAccounts != null) {
                let accountsToDeleted = ui.deletedAccounts.map(id => {
                    return {
                        id: id
                    }
                })
    
                this.gridApi.updateRowData({
                    remove: accountsToDeleted
                });                        
			}
		});

        this.newAccountDisposer = autorun(() => {
            if (ui.newAccount != null) {
                const currentAccount = this.gridApi.getRowNode(
                    ui.newAccount.id
                );

                if (currentAccount == null) {
                    this.gridApi.updateRowData({
                        add: [ui.newAccount]
                    });
                } else {
                    this.gridApi.updateRowData({
                        update: [ui.newAccount]
                    });
                }
            }
        });

        this.updateAccountDisposer = autorun(() => {
            // console.log("Updated account");
            if (ui.updatedAccount != null) {
                //For some reasons, ag-grid didn't re-render the detail row so we first need to remove the updated row
                //and add readd it again
                this.gridApi.updateRowData({
                    remove: [ui.updatedAccount]
                });

                this.gridApi.updateRowData({
                    add: [ui.updatedAccount]
                });
            }
        });
        // this.gridApi.sizeColumnsToFit();
    }

    componentWillUnmount() {
        if (this.deleteAccountDisposer != null) {
            this.deleteAccountDisposer();
        }

        if (this.newAccountDisposer != null) {
            this.newAccountDisposer();
        }

        if (this.updateAccountDisposer != null) {
            this.updateAccountDisposer();
        }
    }

    createGridDefs(columnDefs) {
        const gridDefs = {
            columnDefs: [
                {
                    headerName: "Id",
                    cellRenderer: "agGroupCellRenderer",
                    field: "id",
                    width: 100,
                    suppressSizeToFit: true,
                    editable: false,
                    // headerCheckboxSelection: true,
                    // checkboxSelection: true
                },
                {
                    headerName: "Friendly Name",
                    cellRenderer: "agGroupCellRenderer",
                    field: "friendlyName",
                    width: 300,
                    suppressSizeToFit: true,
                    editable: false,
                    filter: getTextFilter("Friendly Name"),
                    // headerCheckboxSelection: true,
                    // checkboxSelection: true
                },
                {
                    headerName: "Service",
                    width: 100,
                    suppressSizeToFit: true,
                    field: "service",
                    editable: false,
                },
                {
                    headerName: "Action",
                    width: 200,
                    suppressSizeToFit: true,
                    editable: false,
                    cellRendererFramework: (params) => {
                        return <Fragment><Button type="primary" size="small" onClick={() => this.showEditAccountDialog(params.data.id)}>Edit</Button>{" "}
                        <Button type="danger" size="small" onClick={(event) => { console.log(event); event.preventDefault(); this.confirmDeleteAccount(params.data.id) }}>Delete</Button></Fragment>
                    }
                }
            ],
            rowSelection: "multiple"
        };
        return gridDefs;
    }

    showAddAccountDialog = () => {
        const {
            rootStore: { cloudAccountsStore }
        } = this.props;

        const ui = cloudAccountsStore.ui;

        cloudAccountsStore.showAddAccountDialog();
    };

    showEditAccountDialog = (id) => {
        const {
            rootStore: { cloudAccountsStore }
        } = this.props;

        const currentAccount = this.gridApi.getRowNode(id).data;

        cloudAccountsStore.showEditAccountDialog(currentAccount);
    };

    deleteAccount = (id) => {
        const {
            rootStore: { cloudAccountsStore }
        } = this.props;

        cloudAccountsStore.remoteDeleteAccount(id);
    }

    confirmDeleteAccount = (id) => {
        Modal.confirm({
			title: "Delete Cloud Account",
			content: (<span>Do you want to delete the selected cloud account? Deleting the account will delete the cloud blogs on your computer too.</span>),
			onOk: () => this.deleteAccount(id)
		})
    }

    showAddEmailDialog = () => {
        const {
            rootStore: { cloudAccountsStore }
        } = this.props;

        cloudAccountsStore.showAddAccountDialog();
    }

    hideAddAccountDrawer = () => {
        const {
            rootStore: { cloudAccountsStore }
        } = this.props;

        cloudAccountsStore.hideAddAccountDialog();
    };

    addAccount = (payload) => {
        const {
            rootStore: { cloudAccountsStore }
        } = this.props;

        cloudAccountsStore.addAccount(payload);
    }

    render() {
        const {
            rootStore: { cloudAccountsStore }
        } = this.props;

        const ui = cloudAccountsStore.ui;

        let breadcrumbList = "";

        const gridDefs = this.createGridDefs();
        const cloudAccounts = cloudAccountsStore.accounts;
        return (
            <Fragment>
                {ui.loadingAccounts == true ? (
                    ""
                ) : (<PageHeaderLayout
                    breadcrumbList={breadcrumbList}
                    title={"Cloud Accounts"}
                >
                    <Card>
                        <AddCloudAccountDrawer
                            ui={ui}
                            hideDrawer={this.hideAddAccountDrawer}
                            addAccount={this.addAccount}
                        />
                        <EditCloudAccountDrawer
                        />
                        <Row>
                            <Form layout="inline">
                                <Form.Item>
                                    <Tooltip title="Add Account">
                                        <Button
                                            type="primary"
                                            onClick={
                                                this.showAddEmailDialog
                                            }
                                        >
                                            <Icon type="plus-square" />
                                        </Button>
                                    </Tooltip>
                                </Form.Item>
                            </Form>
                        </Row>
                        <Row>
                            <div
                                style={{
                                    width: "100%",
                                    height:
                                        (window.screen.height * 3) / 4
                                }}
                            >
                                <div
                                    style={{
                                        boxSizing: "border-box",
                                        height: "100%",
                                        width: "100%"
                                    }}
                                    className="ag-theme-balham"
                                >
                                    <AgGridReact
                                        style={{ width: '100%', height: '100%' }}
                                        columnDefs={gridDefs.columnDefs}
                                        enableColResize={true}
                                        enableFilter={true}
                                        floatingFilter={true}
                                        enableSorting={true}
                                        rowData={cloudAccounts}
                                        enableRangeSelection={false}
                                        suppressCopyRowsToClipboard={true}
                                        // rowSelection={
                                        //     gridDefs.rowSelection
                                        // }
                                        suppressRowClickSelection={true}
                                        // onRowSelected={
                                        //     this.onRowSelected
                                        // }
                                        getRowNodeId={data => {
                                            return data.id;
                                        }}
                                        masterDetail={true}
                                        isRowMaster={data => {
                                            return true;
                                        }}
                                        deltaRowDataMode={true}
                                        detailCellRendererFramework={(params) => {
                                            console.log("Detailed row", params);
                                            const info = params.data.info;
                                            const cred = JSON.parse(info);
                                            switch (params.data.service) {
                                                case CloudServicesEnum.S3:
                                                    return (
                                                        <Form layout={"vertical"} style={{ margin: 10 }}>
                                                            <Col span={8} style={{ marginRight: 20 }}><Form.Item label="Access Key">
                                                                <Input readOnly value={cred.accessKey} />
                                                            </Form.Item></Col>
                                                            <Col span={8}>
                                                                <Form.Item label="Secret Key">
                                                                    <Input readOnly value={cred.secretKey} />
                                                                </Form.Item>
                                                            </Col>
                                                        </Form>
                                                    )
                                                case CloudServicesEnum.Azure:
                                                    return (
                                                        <Form layout={"vertical"} style={{ margin: 10 }}>
                                                            <Form.Item label="Connection String">
                                                                <Input readOnly value={cred.connectionString} />
                                                            </Form.Item>
                                                        </Form>
                                                    )
                                                case CloudServicesEnum.Google:
                                                    return (
                                                        <Form layout={"vertical"} style={{ margin: 10 }}>
                                                            <Form.Item label="Credentials">
                                                                <Input readOnly value={cred.credentials} />
                                                            </Form.Item>
                                                        </Form>
                                                    )
                                                default:
                                                    return "";
                                            };
                                        }}
                                        onGridReady={this.onGridReady}
                                        groupDefaultExpanded={-1}
                                        getRowHeight={(params) => {
                                            if (params.node.detail) {
                                                return 80
                                            } else {
                                                return 30
                                            }
                                        }}
                                        suppressContextMenu={true}
                                    />
                                </div>
                            </div>
                        </Row>
                    </Card>
                </PageHeaderLayout>)}
            </Fragment>

        )
    }
}

export default CloudAccountsPage;